import React, { useState } from "react";
import { useSelector } from "react-redux";

import TableHead from "../../UI/TableUI/TableHead";
import { allExpenseHeadList } from "../../../utils/TableHeadList";
import { formatDate } from "../../../functions/dateTime/formatDate";
import NoDataDisplay from "../../UI/NoDataDisplay";
import sortDataByDate from "../../../functions/sorting/sortDataByDate";
import { getExpenseStatus } from "../../../functions/getExpenseStatus";
import MobileActionHeader from "../../UI/headingsUI/MobileActionHeader";
import { filterCategoryExpense } from "../../../utils/filterCategoryList";
import { expenseSearch } from "../../../utils/tableSearchList";
import FilterSearch from "../../common/FilterSearch";
import ExpenseViewDialog from "../../UI/viewDialogs/expense/ExpenseViewDialog";
import ImageSlider from "../../UI/viewDialogs/ImageSlider";
import ExpenseCategoryTabs from "./ExpenseCategoryTabs";
import UsePermissionsClaim from "../../../CustomHooks/UsePermissionsClaim";
import { truncateDesc } from "../../../functions/truncateDesc";

const Expense = ({ expenseData }) => {
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();
  const isSorted = useSelector((state) => state.data.isSorted);
  const { checkPermission } = UsePermissionsClaim();
  const permAddExpense = checkPermission("add_expense");

  let dataList = isSorted ? expenseData : sortDataByDate(expenseData, "date");
  const isDataAvailable = expenseData?.length > 0;

  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    setImageSliderPics([]);
    setViewDialogDetails({ ...viewDialogDetails, open: true });
  };
  const isMobile = window.innerWidth < 1000;
  return (
    <>
      {isMobile && (
        <MobileActionHeader
          navigate={"/expense/add"}
          btnText={permAddExpense ? "Add Expense" : undefined}
        >
          <ExpenseCategoryTabs />
        </MobileActionHeader>
      )}
      <FilterSearch
        categories={filterCategoryExpense}
        searchCategories={expenseSearch}
        addBtnNavigation={"/expense/add"}
        addBtnText={permAddExpense ? "Add Expense" : undefined}
      />

      <div className={`table-container table-height`}>
        <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
          <tbody>
            <TableHead headList={allExpenseHeadList} />
            {isDataAvailable ? (
              <>
                {dataList.map((data, index) => {
                  return (
                    <tr className="table-row" key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {data.user.fullName} (U) <br></br>
                        {data.receiver && <>{data.receiver.fullName} (R)</>}
                      </td>
                      <td>{`₹${data.amount}`}</td>
                      <td>{truncateDesc(data.description)}</td>
                      <td>
                        {formatDate(data.date)}
                        {data.backDated && (
                          <span className="backDatedBtn">BD</span>
                        )}
                      </td>
                      <td>{data.category.name}</td>
                      <td
                        className={`status-data ${
                          getExpenseStatus(data.state).textColor
                        }`}
                      >
                        {getExpenseStatus(data.state).status}
                      </td>
                      <td>
                        <button
                          className="tableViewBtn"
                          onClick={() =>
                            setViewDialogDetails({ open: true, data: data })
                          }
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <NoDataDisplay />
            )}
          </tbody>
        </table>
      </div>
      {viewDialogDetails?.open && (
        <ExpenseViewDialog
          closeDialog={closeViewDialog}
          viewDetails={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          setExpenseViewDetails={setViewDialogDetails}
          currentListTab={true}
        />
      )}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Expense Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};
export default Expense;
